export const FETCH_DISABLED_GROUP_LABEL = 'Disable message loads by type';

export const FETCH_DISABLED_CONFIG = Object.freeze({
  skeleton: {
    storageKey: 'output:skeleton-fetch-disbled',
    label: 'Skeleton messages',
  },
  zombie: {
    storageKey: 'output:zombie-fetch-disbled',
    label: 'Zombie messages',
  },
  regular: {
    storageKey: 'output:regular-fetch-disbled',
    label: 'Regular messages',
  },
});

export const FETCH_DISABLED_TYPES = Object.freeze(['skeleton', 'zombie', 'regular']);

export const readFetchDisabledFlag = (type) => {
  const config = FETCH_DISABLED_CONFIG[type];
  if (!config) return false;

  try {
    const stored = window.localStorage.getItem(config.storageKey);
    if (stored === '1') return true;
    if (stored === '0') return false;
    window.localStorage.setItem(config.storageKey, '0');
  } catch {
    return false;
  }

  return false;
};

export const writeFetchDisabledFlag = (type, disabled) => {
  const config = FETCH_DISABLED_CONFIG[type];
  if (!config) return;

  try {
    window.localStorage.setItem(config.storageKey, disabled ? '1' : '0');
  } catch {
    // no-op
  }
};
